const PlayerData = [
  {
    player_id: 3820,
    player_name: 'Artem Dzyuba',
    player_known_name: '',
    player_birth_date: '22/08/1988',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 1165,
    player_name: 'Danny Rose',
    player_known_name: '',
    player_birth_date: '02/07/1990',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 296172,
    player_name: 'Harry Maguire',
    player_known_name: '',
    player_birth_date: '05/03/1993',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 3427,
    player_name: 'Thomas Delaney',
    player_known_name: '',
    player_birth_date: '03/09/1991',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 17198,
    player_name: 'Marouane Fellaini-Bakkioui',
    player_known_name: 'Marouane Fellaini',
    player_birth_date: '22/11/1987',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 12592,
    player_name: 'Miguel Arturo Layún Prado',
    player_known_name: 'Miguel Layún',
    player_birth_date: '25/06/1988',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 3631,
    player_name: 'Davinson Sánchez Mina',
    player_known_name: 'Davinson Sánchez',
    player_birth_date: '12/06/1996',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 10767,
    player_name: 'Fágner Conserva Lemos',
    player_known_name: 'Fágner',
    player_birth_date: '11/06/1989',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 3203,
    player_name: 'Vladimir Granat',
    player_known_name: '',
    player_birth_date: '22/05/1987',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 20319,
    player_name: 'Federico Julián Fazio',
    player_known_name: 'Federico Fazio',
    player_birth_date: '17/03/1987',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 14083,
    player_name: 'Andrés Iniesta Luján',
    player_known_name: 'Andrés Iniesta',
    player_birth_date: '11/05/1984',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 288622,
    player_name: 'Rodrigo Bentancur Colmán',
    player_known_name: 'Rodrigo Bentancur',
    player_birth_date: '25/06/1997',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 13421,
    player_name: 'Toby Alderweireld',
    player_known_name: '',
    player_birth_date: '02/03/1989',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 19371,
    player_name: 'Francisco Román Alarcón Suárez',
    player_known_name: 'Isco',
    player_birth_date: '21/04/1992',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 16638,
    player_name: 'Florian Thauvin',
    player_known_name: '',
    player_birth_date: '26/01/1993',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 15970,
    player_name: 'Samuel Yves Umtiti',
    player_known_name: 'Samuel Umtiti',
    player_birth_date: '14/11/1993',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 1187,
    player_name: 'Thomas Vermaelen',
    player_known_name: '',
    player_birth_date: '14/11/1985',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 9279,
    player_name: 'Alisson Ramsés Becker',
    player_known_name: 'Alisson',
    player_birth_date: '02/10/1992',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 19867,
    player_name: 'Haris Seferović',
    player_known_name: '',
    player_birth_date: '22/02/1992',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 1316,
    player_name: 'David Josué Jiménez Silva',
    player_known_name: 'David Silva',
    player_birth_date: '08/01/1986',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 18811,
    player_name: 'Blaise Matuidi',
    player_known_name: '',
    player_birth_date: '09/04/1987',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 16743,
    player_name: 'Ante Rebić',
    player_known_name: '',
    player_birth_date: '21/09/1993',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 23368,
    player_name: 'Johan Danon Djourou-Gbadjere',
    player_known_name: 'Johan Djourou',
    player_birth_date: '18/01/1987',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 981598,
    player_name: 'Breel-Donald Embolo',
    player_known_name: 'Breel Embolo',
    player_birth_date: '14/02/1997',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 5558559,
    player_name: 'Nahitan Michel Nández Acosta',
    player_known_name: 'Nahitan Nández',
    player_birth_date: '28/12/1995',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 1966,
    player_name: 'Henrik Dalsgaard',
    player_known_name: '',
    player_birth_date: '27/07/1989',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 15068,
    player_name: 'John Stones',
    player_known_name: '',
    player_birth_date: '28/05/1994',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 19471,
    player_name: 'Hugo Ayala Castro',
    player_known_name: 'Hugo Ayala',
    player_birth_date: '31/03/1987',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 9648,
    player_name: 'Wílmar Enrique Barrios Terán',
    player_known_name: 'Wílmar Barrios',
    player_birth_date: '16/10/1993',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 18880,
    player_name: 'Edinson Roberto Cavani Gómez',
    player_known_name: 'Edinson Cavani',
    player_birth_date: '14/02/1987',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 11577,
    player_name: 'José Paulo Bezzera Maciel Júnior',
    player_known_name: 'Paulinho',
    player_birth_date: '25/07/1988',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 20934,
    player_name: 'José Andrés Guardado Hernández',
    player_known_name: 'Andrés Guardado',
    player_birth_date: '28/09/1986',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 3304738,
    player_name: 'Marcus Berg',
    player_known_name: '',
    player_birth_date: '17/08/1986',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 15289,
    player_name: 'Romelu Lukaku Menama',
    player_known_name: 'Romelu Lukaku',
    player_birth_date: '13/05/1993',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 14164,
    player_name: 'Genki Haraguchi',
    player_known_name: '',
    player_birth_date: '09/05/1991',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 14810,
    player_name: 'Eiji Kawashima',
    player_known_name: '',
    player_birth_date: '20/03/1983',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 19221,
    player_name: 'Sergio Ramos García',
    player_known_name: 'Sergio Ramos',
    player_birth_date: '30/03/1986',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 2732,
    player_name: 'Igor Akinfeev',
    player_known_name: '',
    player_birth_date: '08/04/1986',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 13942,
    player_name: 'Javier Alejandro Mascherano',
    player_known_name: 'Javier Mascherano',
    player_birth_date: '08/06/1984',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 19612,
    player_name: 'Jan Vertonghen',
    player_known_name: '',
    player_birth_date: '24/04/1987',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 14447,
    player_name: 'Albin Ekdal',
    player_known_name: '',
    player_birth_date: '28/07/1989',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 16931,
    player_name: 'Phil Jones',
    player_known_name: '',
    player_birth_date: '21/02/1992',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 8700,
    player_name: 'Keisuke Honda',
    player_known_name: '',
    player_birth_date: '13/06/1986',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 611277,
    player_name: 'Kylian Mbappé Lottin',
    player_known_name: 'Kylian Mbappé',
    player_birth_date: '20/12/1998',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 18673,
    player_name: 'Thiago Emiliano da Silva',
    player_known_name: 'Thiago Silva',
    player_birth_date: '22/09/1984',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 5677146,
    player_name: 'Cristian Eduardo Zapata Valencia',
    player_known_name: 'Cristián Zapata',
    player_birth_date: '30/09/1986',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 6830,
    player_name: 'Martin Braithwaite Christensen',
    player_known_name: 'Martin Braithwaite',
    player_birth_date: '05/06/1991',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 300386,
    player_name: 'Bamidele Alli',
    player_known_name: 'Dele Alli',
    player_birth_date: '11/04/1996',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 19428,
    player_name: 'Cristiano Ronaldo dos Santos Aveiro',
    player_known_name: 'Cristiano Ronaldo',
    player_birth_date: '05/02/1985',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 13509,
    player_name: 'Lucas Hernández Pi',
    player_known_name: 'Lucas Hernandez',
    player_birth_date: '14/02/1996',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 5568520,
    player_name: 'Pione Sisto Ifolo Emirmija',
    player_known_name: 'Pione Sisto',
    player_birth_date: '04/02/1995',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 14909,
    player_name: 'Santiago Arias Naranjo',
    player_known_name: 'Santiago Arias',
    player_birth_date: '13/01/1992',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 2561,
    player_name: 'Fyodor Smolov',
    player_known_name: '',
    player_birth_date: '09/02/1990',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 5464,
    player_name: 'Aleksandr Samedov',
    player_known_name: '',
    player_birth_date: '19/07/1984',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 289719,
    player_name: 'Marcelo Brozović',
    player_known_name: '',
    player_birth_date: '16/11/1992',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 19246,
    player_name: 'Marcelo Vieira da Silva Júnior',
    player_known_name: 'Marcelo',
    player_birth_date: '12/05/1988',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 19032,
    player_name: 'Paul Pogba',
    player_known_name: '',
    player_birth_date: '15/03/1993',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 12777,
    player_name: 'Néstor Fernando Muslera Micol',
    player_known_name: 'Fernando Muslera',
    player_birth_date: '16/06/1986',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 625403,
    player_name: 'Gabriel Fernando de Jesus',
    player_known_name: 'Gabriel Jesus',
    player_birth_date: '03/04/1997',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 15111,
    player_name: 'Ricardo Andrade Quaresma Bernardo',
    player_known_name: 'Ricardo Quaresma',
    player_birth_date: '26/09/1983',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 5650003,
    player_name: 'Luis Fernando Muriel Fruto',
    player_known_name: 'Luis Muriel',
    player_birth_date: '16/04/1991',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 13030,
    player_name: 'Marco Asensio Willemsen',
    player_known_name: 'Marco Asensio',
    player_birth_date: '21/01/1996',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 6967,
    player_name: 'Pontus Jansson',
    player_known_name: '',
    player_birth_date: '13/02/1991',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 966390,
    player_name: 'Edson Omar Álvarez Velázquez',
    player_known_name: 'Edson Álvarez',
    player_birth_date: '24/10/1997',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 13348,
    player_name: 'Thibaut Courtois',
    player_known_name: '',
    player_birth_date: '11/05/1992',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 1599,
    player_name: 'Vincent Kompany',
    player_known_name: '',
    player_birth_date: '10/04/1986',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 12256,
    player_name: 'Carlos Henrique Casimiro',
    player_known_name: 'Casemiro',
    player_birth_date: '23/02/1992',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 16437,
    player_name: 'Luis Alberto Suárez Díaz',
    player_known_name: 'Luis Suárez',
    player_birth_date: '24/01/1987',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 5116,
    player_name: 'Renato Soares de Oliveira Augusto',
    player_known_name: 'Renato Augusto',
    player_birth_date: '08/02/1988',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 13888,
    player_name: 'Enzo Nicolás Pérez',
    player_known_name: 'Enzo Pérez',
    player_birth_date: '22/02/1986',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 19665,
    player_name: 'Makoto Hasebe',
    player_known_name: '',
    player_birth_date: '18/01/1984',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 20619,
    player_name: 'Roberto Firmino Barbosa de Oliveira',
    player_known_name: 'Roberto Firmino',
    player_birth_date: '02/10/1991',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 5577288,
    player_name: 'Jesús Daniel Gallardo Vasconcelos',
    player_known_name: 'Jesús Gallardo',
    player_birth_date: '15/08/1994',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 19317,
    player_name: 'Denis Cheryshev',
    player_known_name: '',
    player_birth_date: '26/12/1990',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 612069,
    player_name: 'Ousmane Dembélé',
    player_known_name: '',
    player_birth_date: '15/05/1997',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 13458,
    player_name: 'José María Giménez de Vargas',
    player_known_name: 'José Giménez',
    player_birth_date: '20/01/1995',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 5568522,
    player_name: 'Simon Thorup Kjær',
    player_known_name: 'Simon Kjær',
    player_birth_date: '26/03/1989',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 1593,
    player_name: 'Nacer Chadli',
    player_known_name: '',
    player_birth_date: '02/08/1989',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 16371,
    player_name: 'Philippe Coutinho Correia',
    player_known_name: 'Philippe Coutinho',
    player_birth_date: '12/06/1992',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 22322,
    player_name: 'Takashi Inui',
    player_known_name: '',
    player_birth_date: '02/06/1988',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 5097619,
    player_name: 'Manuel Obafemi Akanji',
    player_known_name: 'Manuel Akanji',
    player_birth_date: '19/07/1995',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 5308,
    player_name: 'Vedran Ćorluka',
    player_known_name: '',
    player_birth_date: '05/02/1986',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 3424,
    player_name: 'Franco Armani',
    player_known_name: '',
    player_birth_date: '16/10/1986',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 14636,
    player_name: 'Michael Krohn-Dehli',
    player_known_name: '',
    player_birth_date: '06/06/1983',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 13974,
    player_name: 'Jordi Alba Ramos',
    player_known_name: 'Jordi Alba',
    player_birth_date: '',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 5606370,
    player_name: 'Diego Sebastián Laxalt Suárez',
    player_known_name: 'Diego Laxalt',
    player_birth_date: '07/02/1993',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 2896,
    player_name: 'Steven Zuber',
    player_known_name: '',
    player_birth_date: '17/08/1991',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 6661,
    player_name: 'Fedor Kudryashov',
    player_known_name: '',
    player_birth_date: '05/04/1987',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 18118,
    player_name: 'Yuto Nagatomo',
    player_known_name: '',
    player_birth_date: '12/09/1986',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 14226,
    player_name: 'Lionel Andrés Messi Cuccittini',
    player_known_name: 'Lionel Messi',
    player_birth_date: '24/06/1987',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 908,
    player_name: 'Manuel Henrique Tavares Fernandes',
    player_known_name: 'Manuel Fernandes',
    player_birth_date: '05/02/1986',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 18157,
    player_name: 'Dejan Lovren',
    player_known_name: '',
    player_birth_date: '05/07/1989',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 288640,
    player_name: 'Cristian David Pavón',
    player_known_name: 'Cristian Pavón',
    player_birth_date: '21/01/1996',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 11351,
    player_name: 'Gaku Shibasaki',
    player_known_name: '',
    player_birth_date: '28/05/1992',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 19204,
    player_name: 'Raphaël Varane',
    player_known_name: '',
    player_birth_date: '25/04/1993',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 18194,
    player_name: 'David Ospina Ramírez',
    player_known_name: 'David Ospina',
    player_birth_date: '31/08/1988',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 17862,
    player_name: 'Rui Pedro dos Santos Patrício',
    player_known_name: 'Rui Patrício',
    player_birth_date: '15/02/1988',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 292628,
    player_name: 'Nicolás Alejandro Tagliafico',
    player_known_name: 'Nicolás Tagliafico',
    player_birth_date: '31/08/1992',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 12203,
    player_name: 'Neymar da Silva Santos Junior',
    player_known_name: 'Neymar',
    player_birth_date: '05/02/1992',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 8546,
    player_name: 'Kasper Schmeichel',
    player_known_name: '',
    player_birth_date: '05/11/1986',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 17296,
    player_name: 'Radamel Falcao García Zárate',
    player_known_name: 'Radamel Falcao',
    player_birth_date: '10/02/1986',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 21065,
    player_name: 'Ivan Strinić',
    player_known_name: '',
    player_birth_date: '17/07/1987',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 15983,
    player_name: 'Corentin Tolisso',
    player_known_name: '',
    player_birth_date: '03/08/1994',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 17844,
    player_name: 'Martin Olsson',
    player_known_name: '',
    player_birth_date: '17/05/1988',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 16211,
    player_name: 'Nabil Fekir',
    player_known_name: '',
    player_birth_date: '18/07/1993',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 1557,
    player_name: 'Maya Yoshida',
    player_known_name: '',
    player_birth_date: '24/08/1988',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 14491,
    player_name: 'Matías Vecino Falero',
    player_known_name: 'Matías Vecino',
    player_birth_date: '24/08/1991',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 19285,
    player_name: 'José Ignacio Fernández Iglesias',
    player_known_name: 'Nacho',
    player_birth_date: '18/01/1990',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 18103,
    player_name: 'Carlos Andrés Sánchez Arcosa',
    player_known_name: 'Carlos Andrés Sánchez',
    player_birth_date: '02/12/1984',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 18229,
    player_name: 'Ola Toivonen',
    player_known_name: '',
    player_birth_date: '03/07/1986',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 2995,
    player_name: 'Jonas Knudsen',
    player_known_name: '',
    player_birth_date: '16/09/1992',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 10016,
    player_name: 'Yūya Ōsako',
    player_known_name: '',
    player_birth_date: '18/05/1990',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 20509,
    player_name: 'Ivan Rakitić',
    player_known_name: '',
    player_birth_date: '10/03/1988',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 5636302,
    player_name: 'Yerry Fernando Mina González',
    player_known_name: 'Yerry Mina',
    player_birth_date: '23/09/1994',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 23425,
    player_name: 'Milan Badelj',
    player_known_name: '',
    player_birth_date: '25/02/1989',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 299071,
    player_name: 'Andrej Kramarić',
    player_known_name: '',
    player_birth_date: '19/06/1991',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 4754,
    player_name: 'Emil Krafth',
    player_known_name: '',
    player_birth_date: '02/08/1994',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 13736,
    player_name: 'Diego da Silva Costa',
    player_known_name: 'Diego Costa',
    player_birth_date: '07/10/1988',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 5097616,
    player_name: 'Michael Lang',
    player_known_name: '',
    player_birth_date: '08/02/1991',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 6001,
    player_name: 'Maximiliano Eduardo Meza',
    player_known_name: 'Maximiliano Meza',
    player_birth_date: '15/12/1992',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 14889,
    player_name: 'Mathias Jattah-Njie Jørgensen',
    player_known_name: 'Zanka',
    player_birth_date: '23/04/1990',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 4876494,
    player_name: 'Mikael Lustig',
    player_known_name: '',
    player_birth_date: '13/12/1986',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 16805,
    player_name: 'Sergio Leonel Agüero del Castillo',
    player_known_name: 'Sergio Agüero',
    player_birth_date: '02/06/1988',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 8586,
    player_name: 'Willian Borges da Silva',
    player_known_name: 'Willian',
    player_birth_date: '09/08/1988',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 19838,
    player_name: 'Harry Kane',
    player_known_name: '',
    player_birth_date: '28/07/1993',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 610175,
    player_name: 'André Miguel Valente Silva',
    player_known_name: 'André Silva',
    player_birth_date: '06/11/1995',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 21281,
    player_name: 'Valon Behrami',
    player_known_name: '',
    player_birth_date: '19/04/1985',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 286383,
    player_name: 'Aleksandr Golovin',
    player_known_name: '',
    player_birth_date: '30/05/1996',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 3566,
    player_name: 'Nicolai Jørgensen',
    player_known_name: '',
    player_birth_date: '15/01/1991',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 297753,
    player_name: 'Andreas Christensen',
    player_known_name: '',
    player_birth_date: '10/04/1996',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 13993,
    player_name: 'Rodrigo Moreno Machado',
    player_known_name: 'Rodrigo',
    player_birth_date: '06/03/1991',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 297933,
    player_name: 'Ruben Loftus-Cheek',
    player_known_name: '',
    player_birth_date: '23/01/1996',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 19255,
    player_name: 'Daniel Carvajal Ramos',
    player_known_name: 'Daniel Carvajal',
    player_birth_date: '11/01/1992',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 14104,
    player_name: 'Jonathan dos Santos Ramírez',
    player_known_name: 'Jonathan dos Santos',
    player_birth_date: '26/04/1990',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 12893,
    player_name: 'Olivier Giroud',
    player_known_name: '',
    player_birth_date: '30/09/1986',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 288702,
    player_name: 'Benjamin Pavard',
    player_known_name: '',
    player_birth_date: '28/03/1996',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 15297,
    player_name: 'Ricardo Domingos Barbosa Pereira',
    player_known_name: 'Ricardo Pereira',
    player_birth_date: '06/10/1993',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 21242,
    player_name: 'Blerim Džemaili',
    player_known_name: '',
    player_birth_date: '12/04/1986',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 1398,
    player_name: "Steven N'Kemboanza Mike Christopher Nzonzi",
    player_known_name: 'Steven Nzonzi',
    player_birth_date: '',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 1562,
    player_name: 'Fabian Delph',
    player_known_name: '',
    player_birth_date: '21/11/1989',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 14249,
    player_name: 'Eden Hazard',
    player_known_name: '',
    player_birth_date: '07/01/1991',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 5568511,
    player_name: 'Éver Maximiliano David Banega',
    player_known_name: 'Éver Banega',
    player_birth_date: '29/06/1988',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 8648,
    player_name: 'Gabriel Iván Mercado',
    player_known_name: 'Gabriel Mercado',
    player_birth_date: '18/03/1987',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 13395,
    player_name: 'Filipe Luis Kasmirski',
    player_known_name: 'Filipe Luis',
    player_birth_date: '09/08/1985',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 12830,
    player_name: 'Raúl Alonso Jiménez Rodríguez',
    player_known_name: 'Raúl Jiménez',
    player_birth_date: '05/05/1991',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 5802,
    player_name: 'Johan Andrés Mojica Palacio',
    player_known_name: 'Johan Mojica',
    player_birth_date: '21/08/1992',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 8893,
    player_name: 'Jamie Vardy',
    player_known_name: '',
    player_birth_date: '11/01/1987',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 13616,
    player_name: 'Cristian Gabriel Rodríguez Barrotti',
    player_known_name: 'Cristian Rodríguez',
    player_birth_date: '30/09/1985',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 11313,
    player_name: 'Gen Shōji',
    player_known_name: '',
    player_birth_date: '11/12/1992',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 17180,
    player_name: 'Yannick Ferreira Carrasco',
    player_known_name: 'Yannick Carrasco',
    player_birth_date: '04/09/1993',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 970614,
    player_name: 'Marko Pjaca',
    player_known_name: '',
    player_birth_date: '06/05/1995',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 17946,
    player_name: 'Eric Dier',
    player_known_name: '',
    player_birth_date: '15/01/1994',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 17938,
    player_name: 'Faustino Marcos Alberto Rojo',
    player_known_name: 'Marcos Rojo',
    player_birth_date: '20/03/1990',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 8183,
    player_name: 'Axel Witsel',
    player_known_name: '',
    player_birth_date: '12/01/1989',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 18682,
    player_name: 'Marcos Aoás Corrêa',
    player_known_name: 'Marquinhos',
    player_birth_date: '14/05/1994',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 19761,
    player_name: 'Antoine Griezmann',
    player_known_name: '',
    player_birth_date: '21/03/1991',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 4190,
    player_name: "N'Golo Kanté",
    player_known_name: '',
    player_birth_date: '',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 17229,
    player_name: 'Javier Hernández Balcázar',
    player_known_name: 'Javier Hernández',
    player_birth_date: '01/06/1988',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 16862,
    player_name: 'David de Gea Quintana',
    player_known_name: 'David de Gea',
    player_birth_date: '07/11/1990',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 16879,
    player_name: 'Danijel Subašić',
    player_known_name: '',
    player_birth_date: '27/10/1984',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 1181,
    player_name: 'Kyle Walker',
    player_known_name: '',
    player_birth_date: '28/05/1990',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 13498,
    player_name: 'João Miranda de Souza Filho',
    player_known_name: 'João Miranda',
    player_birth_date: '07/09/1984',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 2784,
    player_name: 'Mário Figueira Fernandes',
    player_known_name: 'Mário Fernandes',
    player_birth_date: '19/09/1990',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 4007,
    player_name: 'Andreas Granqvist',
    player_known_name: '',
    player_birth_date: '16/04/1985',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 10771,
    player_name: 'Hotaru Yamaguchi',
    player_known_name: '',
    player_birth_date: '06/10/1990',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 18164,
    player_name: 'José Miguel da Rocha Fonte',
    player_known_name: 'José Fonte',
    player_birth_date: '22/12/1983',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 3078,
    player_name: 'Jefferson Andrés Lerma Solís',
    player_known_name: 'Jefferson Lerma',
    player_birth_date: '25/10/1994',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 2796,
    player_name: 'Sergei Ignashevich',
    player_known_name: '',
    player_birth_date: '14/07/1979',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 5647,
    player_name: 'Kieran Trippier',
    player_known_name: '',
    player_birth_date: '19/09/1990',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 17209,
    player_name: 'Šime Vrsaljko',
    player_known_name: '',
    player_birth_date: '10/01/1992',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 1121,
    player_name: 'Ashley Young',
    player_known_name: '',
    player_birth_date: '09/07/1985',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 636328,
    player_name: 'Marcus Rashford',
    player_known_name: '',
    player_birth_date: '31/10/1997',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 13975,
    player_name: 'Youri Tielemans',
    player_known_name: '',
    player_birth_date: '07/05/1997',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 7268185,
    player_name: 'Kléper Laveran Lima Ferreira',
    player_known_name: 'Pepe',
    player_birth_date: '26/02/1983',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 6996,
    player_name: 'Andrés Mateus Uribe Villa',
    player_known_name: 'Mateus Uribe',
    player_birth_date: '21/03/1991',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 16386,
    player_name: 'Jordan Brian Henderson',
    player_known_name: 'Jordan Henderson',
    player_birth_date: '17/06/1990',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 21846,
    player_name: 'Granit Xhaka',
    player_known_name: '',
    player_birth_date: '27/09/1992',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 19364,
    player_name: 'Ángel Fabián Di María Hernández',
    player_known_name: 'Ángel Di María',
    player_birth_date: '14/02/1988',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 5596276,
    player_name: 'Carlos Arturo Bacca Ahumada',
    player_known_name: 'Carlos Bacca',
    player_birth_date: '08/09/1986',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 17181,
    player_name: 'Shinji Kagawa',
    player_known_name: '',
    player_birth_date: '17/03/1989',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 3575,
    player_name: 'Andreas Evald Cornelius',
    player_known_name: 'Andreas Cornelius',
    player_birth_date: '16/03/1993',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 6971,
    player_name: 'Carlos Joel Salcedo Hernández',
    player_known_name: 'Carlos Salcedo',
    player_birth_date: '29/09/1993',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 16467,
    player_name: 'Iago Aspas Juncal',
    player_known_name: 'Iago Aspas',
    player_birth_date: '01/08/1987',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 7171,
    player_name: 'Emil Forsberg',
    player_known_name: '',
    player_birth_date: '23/10/1991',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 2915,
    player_name: 'Alan Dzagoev',
    player_known_name: '',
    player_birth_date: '17/06/1990',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 3680,
    player_name: 'Viktor Claesson',
    player_known_name: '',
    player_birth_date: '02/01/1992',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 13909,
    player_name: 'Gerard Piqué Bernabéu',
    player_known_name: 'Gerard Piqué',
    player_birth_date: '02/02/1987',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 22874,
    player_name: 'Xherdan Shaqiri',
    player_known_name: '',
    player_birth_date: '10/10/1991',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 24369,
    player_name: 'Ricardo Iván Rodríguez Araya',
    player_known_name: 'Ricardo Rodríguez',
    player_birth_date: '25/08/1992',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 16419,
    player_name: 'Raheem Shaquille Sterling',
    player_known_name: 'Raheem Sterling',
    player_birth_date: '08/12/1994',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 17690,
    player_name: 'Christian Dannemann Eriksen',
    player_known_name: 'Christian Eriksen',
    player_birth_date: '14/02/1992',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 19559,
    player_name: 'Nicolás Hernán Otamendi',
    player_known_name: 'Nicolás Otamendi',
    player_birth_date: '12/02/1988',
    country_id: 12,
    country_name: 'Argentina',
    country_code: 'ar'
  },
  {
    player_id: 5091570,
    player_name: 'Josip Pivarić',
    player_known_name: '',
    player_birth_date: '30/01/1989',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 18063,
    player_name: 'Adrien Sebastian Perruchet Silva',
    player_known_name: 'Adrien Silva',
    player_birth_date: '15/03/1989',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 13912,
    player_name: 'Victor Nilsson Lindelöf',
    player_known_name: 'Victor Lindelöf',
    player_birth_date: '17/07/1994',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 16213,
    player_name: 'Rafael Márquez Álvarez',
    player_known_name: 'Rafael Márquez',
    player_birth_date: '13/02/1979',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 6864,
    player_name: 'Robin Olsen',
    player_known_name: '',
    player_birth_date: '08/01/1990',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 6782,
    player_name: 'Daler Kuzyaev',
    player_known_name: '',
    player_birth_date: '15/01/1993',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 16826,
    player_name: 'John Guidetti',
    player_known_name: '',
    player_birth_date: '15/04/1992',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 19022,
    player_name: 'Sebastian Larsson',
    player_known_name: '',
    player_birth_date: '06/06/1985',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 23606,
    player_name: 'Hiroki Sakai',
    player_known_name: '',
    player_birth_date: '12/04/1990',
    country_id: 78,
    country_name: 'Japan',
    country_code: 'jp'
  },
  {
    player_id: 3272980,
    player_name: 'Maximiliano Gómez González',
    player_known_name: 'Maxi Gómez',
    player_birth_date: '14/08/1996',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 5525,
    player_name: 'Jesse Lingard',
    player_known_name: '',
    player_birth_date: '15/12/1992',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 631003,
    player_name: 'Douglas Costa de Souza',
    player_known_name: 'Douglas Costa',
    player_birth_date: '14/09/1990',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 19881,
    player_name: 'Carlos Alberto Vela Garrido',
    player_known_name: 'Carlos Vela',
    player_birth_date: '01/03/1989',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 15654,
    player_name: 'Cristhian Ricardo Stuani Curbelo',
    player_known_name: 'Cristhian Stuani',
    player_birth_date: '12/10/1986',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 1240,
    player_name: 'Lasse Schöne',
    player_known_name: '',
    player_birth_date: '27/05/1986',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 12504,
    player_name: 'Francisco Guillermo Ochoa Magaña',
    player_known_name: 'Guillermo Ochoa',
    player_birth_date: '13/07/1985',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 7537,
    player_name: 'Aleksandr Erokhin',
    player_known_name: '',
    player_birth_date: '13/10/1989',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 17593,
    player_name: 'Hirving Rodrigo Lozano Bahena',
    player_known_name: 'Hirving Lozano',
    player_birth_date: '30/07/1995',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 302986,
    player_name: 'Yann Sommer',
    player_known_name: '',
    player_birth_date: '17/12/1988',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 13856,
    player_name: 'Jonathan Matías Urretaviscaya da Luz',
    player_known_name: 'Jonathan Urretaviscaya',
    player_birth_date: '19/03/1990',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 21219,
    player_name: 'Jordan Pickford',
    player_known_name: '',
    player_birth_date: '07/03/1994',
    country_id: 618,
    country_name: 'England',
    country_code: 'gb-eng'
  },
  {
    player_id: 14140,
    player_name: 'Kevin De Bruyne',
    player_known_name: '',
    player_birth_date: '28/06/1991',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 292791,
    player_name: 'Yussuf Yurary Poulsen',
    player_known_name: 'Yussuf Poulsen',
    player_birth_date: '15/06/1994',
    country_id: 248,
    country_name: 'Denmark',
    country_code: 'dk'
  },
  {
    player_id: 15327,
    player_name: 'Michy Batshuayi Tunga',
    player_known_name: 'Michy Batshuayi',
    player_birth_date: '02/10/1993',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 15426,
    player_name: 'Raphaël Adelino José Guerreiro',
    player_known_name: 'Raphaël Guerreiro',
    player_birth_date: '22/12/1993',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 18832,
    player_name: 'José Martín Cáceres Silva',
    player_known_name: 'Martín Cáceres',
    player_birth_date: '07/04/1987',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 304252,
    player_name: 'Gustav Svensson',
    player_known_name: '',
    player_birth_date: '07/02/1987',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 16556,
    player_name: 'Juan Guillermo Cuadrado Bello',
    player_known_name: 'Juan Cuadrado',
    player_birth_date: '26/05/1988',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 10784,
    player_name: 'Thomas Meunier',
    player_known_name: '',
    player_birth_date: '12/09/1991',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 625230,
    player_name: 'Lucas Torreira Di Pascua',
    player_known_name: 'Lucas Torreira',
    player_birth_date: '11/02/1996',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 4079,
    player_name: 'Yury Gazinskiy',
    player_known_name: '',
    player_birth_date: '20/07/1989',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 3260,
    player_name: 'Yuri Zhirkov',
    player_known_name: '',
    player_birth_date: '20/08/1983',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 13387,
    player_name: 'Diego Roberto Godín Leal',
    player_known_name: 'Diego Godín',
    player_birth_date: '16/02/1986',
    country_id: 117,
    country_name: 'Uruguay',
    country_code: 'uy'
  },
  {
    player_id: 6475,
    player_name: 'Isaac Kiese Thelin',
    player_known_name: '',
    player_birth_date: '24/06/1992',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 4891316,
    player_name: 'Domagoj Vida',
    player_known_name: '',
    player_birth_date: '29/04/1989',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 14061,
    player_name: 'Sergio Busquets i Burgos',
    player_known_name: 'Sergio Busquets',
    player_birth_date: '16/07/1988',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 18039,
    player_name: 'William Silva de Carvalho',
    player_known_name: 'William Carvalho',
    player_birth_date: '07/04/1992',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 19562,
    player_name: 'Hugo Lloris',
    player_known_name: '',
    player_birth_date: '26/12/1986',
    country_id: 30,
    country_name: 'France',
    country_code: 'fr'
  },
  {
    player_id: 5636,
    player_name: 'Ludwig Augustinsson',
    player_known_name: '',
    player_birth_date: '21/04/1994',
    country_id: 2,
    country_name: 'Sweden',
    country_code: 'se'
  },
  {
    player_id: 5596279,
    player_name: 'Juan Fernando Quintero Paniagua',
    player_known_name: 'Juan Fernando Quintero',
    player_birth_date: '18/01/1993',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 13926,
    player_name: 'Bernardo Mota Veiga de Carvalho e Silva',
    player_known_name: 'Bernardo Silva',
    player_birth_date: '10/08/1994',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 13558,
    player_name: 'Jorge Resurrección Merodio',
    player_known_name: 'Koke',
    player_birth_date: '08/01/1992',
    country_id: 26,
    country_name: 'Spain',
    country_code: 'es'
  },
  {
    player_id: 18872,
    player_name: 'João Mário Naval da Costa Eduardo',
    player_known_name: 'João Mário',
    player_birth_date: '19/01/1993',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 15155,
    player_name: 'Héctor Miguel Herrera López',
    player_known_name: 'Héctor Herrera',
    player_birth_date: '19/04/1990',
    country_id: 1492,
    country_name: 'Mexico',
    country_code: 'mx'
  },
  {
    player_id: 24381,
    player_name: 'Ivan Perišić',
    player_known_name: '',
    player_birth_date: '02/02/1989',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 15158,
    player_name: 'Carlos Alberto Sánchez Moreno',
    player_known_name: 'Carlos Sánchez',
    player_birth_date: '06/02/1986',
    country_id: 250,
    country_name: 'Colombia',
    country_code: 'co'
  },
  {
    player_id: 287460,
    player_name: 'Gonçalo Manuel Ganchinho Guedes',
    player_known_name: 'Gonçalo Guedes',
    player_birth_date: '29/11/1996',
    country_id: 350,
    country_name: 'Portugal',
    country_code: 'pt'
  },
  {
    player_id: 1163,
    player_name: 'Luka Modrić',
    player_known_name: '',
    player_birth_date: '09/09/1985',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 16747,
    player_name: 'Fernando Luiz Rosa',
    player_known_name: 'Fernandinho',
    player_birth_date: '04/05/1985',
    country_id: 9,
    country_name: 'Brazil',
    country_code: 'br'
  },
  {
    player_id: 21226,
    player_name: 'Dries Mertens',
    player_known_name: '',
    player_birth_date: '06/05/1987',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 3378,
    player_name: 'Roman Zobnin',
    player_known_name: '',
    player_birth_date: '11/02/1994',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 19759,
    player_name: 'Josip Drmic',
    player_known_name: '',
    player_birth_date: '08/08/1992',
    country_id: 113,
    country_name: 'Switzerland',
    country_code: 'ch'
  },
  {
    player_id: 22931,
    player_name: 'Mario Mandžukić',
    player_known_name: '',
    player_birth_date: '21/05/1986',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  },
  {
    player_id: 19755,
    player_name: 'Moussa Sidi Yaya Dembélé',
    player_known_name: 'Mousa Dembélé',
    player_birth_date: '16/07/1987',
    country_id: 483,
    country_name: 'Belgium',
    country_code: 'be'
  },
  {
    player_id: 291054,
    player_name: 'Ilya Kutepov',
    player_known_name: '',
    player_birth_date: '29/07/1993',
    country_id: 313,
    country_name: 'Russia',
    country_code: 'ru'
  },
  {
    player_id: 18277,
    player_name: 'Mateo Kovaćić',
    player_known_name: '',
    player_birth_date: '06/05/1994',
    country_id: 8,
    country_name: 'Croatia',
    country_code: 'hr'
  }
]

export default PlayerData
